/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================
*/

import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";
import pxToRem from "assets/theme/functions/pxToRem";

const { inputBorderColor, grey, white } = colors;
const { borderRadius } = borders;
const { size } = typography.size ? typography : { size: {} };

const autocomplete = {
  styleOverrides: {
    popper: {
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
      borderRadius: borderRadius.md,
      zIndex: 10,
    },

    paper: {
      maxHeight: pxToRem(200),
      marginTop: pxToRem(8),
      padding: pxToRem(8),
      borderRadius: borderRadius.md,
      backgroundColor: white.main,
    },

    option: {
      padding: `${pxToRem(8)} ${pxToRem(12)}`,
      fontSize: size?.sm || pxToRem(13),
      color: grey[800],
      borderRadius: borderRadius.sm,
      transition: "background-color 200ms ease",

      "&:hover": {
        backgroundColor: grey[100],
      },

      "&[aria-selected='true']": {
        backgroundColor: grey[200],
      },
    },

    noOptions: {
      fontSize: size?.sm || pxToRem(13),
      padding: pxToRem(8),
      color: grey[500],
    },

    loading: {
      fontSize: size?.sm || pxToRem(13),
      padding: pxToRem(8),
      color: grey[500],
    },
  },
};

export default autocomplete;
